export enum BookingStatus {
    REQUESTED = 'REQUESTED',
    CONFIRMED = 'CONFIRMED',
    REJECTED = 'REJECTED',
    CANCELED = 'CANCELED',
    FINISHED = 'FINISHED'
}

export type BookingResponseItem = {
    id: string;
    offerID: number;
    seekerID: number;
    providerID: number;
    createdAt: string;
    status: BookingStatus;
    seekerNote: string;
    from?: string;
    to?: string;
    checkOut?: string;
    checkIn?: string;
    isStr?: boolean;
    guests?: {
        adults?: number;
        children?: number;
        infants?: number;
    };
};

export type BookingsResponse = {
    bookings: BookingResponseItem[];
};

export type SeekersType = {
    name: string;
    is_online: boolean;
    id: number;
    user_photo?: string;
};

export type BookingSeekerMerged = BookingResponseItem & {
    seekerData: SeekersType;
};

export type UserResponseItem = {
    id: number;
    created: string;
    last_login: string;
    is_business: boolean;
    name: string;
    person: string;
    show_photo: boolean;
    user_photo: string;
    social_network_account_type: 'facebook' | null;
    is_online: boolean;
    last_seen: string;
    user_ads_url: string;
    position: { map_lat: number; map_lon: number };
};

export type UsersResponse = {
    data: UserResponseItem[];
};

export type getUserDetails = (
    ids: string[] | number[]
) => Promise<UsersResponse[]>;

export type TrackingParams = {
    [key: string]: string | number | null;
};

export enum ApiVersion {
    V1 = 'v1',
    V2 = 'v2',
    V3 = 'v3'
}

export enum AppEnvironment {
    Production = 'production',
    Staging = 'staging',
    Development = 'development'
}

export enum Endpoint {
    Atlas = 'Atlas',
    ServiceBooking = 'Booking'
}
